import { createContext } from 'react';

import type { StoreApi } from 'zustand';

import type { FormStore } from '../stores';

export const FormContext = createContext<StoreApi<FormStore> | null>(null);
